import type { ReactNode } from 'react';

import { company } from '~/company/Company';
import {
  type LoadMore,
  useLoadMoreSentinel,
} from '~/hooks/useLoadMoreSentinel';
import { CategorySkeleton } from '~/pages/Catalog/CatalogSkeleton';

interface InfinityScrollLoaderProps {
  onLoadMore: LoadMore;
  className?: string;
  skeletons?: ReactNode;
  embedded?: boolean;
}

export const InfinityScrollLoader = ({
  onLoadMore,
  className = 'block-products',
  skeletons = <CategorySkeleton num={4} />,
  embedded,
}: InfinityScrollLoaderProps) => {
  const ref = useLoadMoreSentinel<HTMLDivElement>(onLoadMore);

  if (embedded) {
    return (
      <>
        {skeletons}
        <div ref={ref} className={className} />
      </>
    );
  }
  return (
    <div ref={ref} data-company={company.name} className={className}>
      {skeletons}
    </div>
  );
};
